/* Sleek game pop-up: drawing and rendering */
(function () {
  var G = window.SleekGame;
  if (!G || !G.C) return;
  var T = G.T;

  function sh(c, shape) {
    return shape.replace(/FILL/g, c);
  }
  G.svg = {
    cover: function (c) {
      if (G.pet) {
        return sh(c, '<svg viewBox="0 0 100 84" aria-hidden="true">' +
          '<path d="M8 72Q10 16 50 12Q90 16 92 72Z" style="fill:FILL"/>' +
          '<path d="M8 72Q10 16 50 12Q90 16 92 72Z" fill="url(#sgsh)"/>' +
          '<rect x="4" y="68" width="92" height="12" rx="6" style="fill:FILL"/>' +
          '<rect x="4" y="68" width="92" height="12" rx="6" fill="rgba(0,0,0,.14)"/>' +
          '<path d="M27 32Q33 21 46 18" stroke="#fff" stroke-opacity=".75" stroke-width="5" fill="none" stroke-linecap="round"/></svg>');
      }
      return sh(c, '<svg viewBox="0 0 100 84" aria-hidden="true">' +
        '<circle cx="50" cy="10" r="6" style="fill:FILL"/><circle cx="50" cy="10" r="6" fill="rgba(0,0,0,.18)"/>' +
        '<path d="M10 72Q10 18 50 15Q90 18 90 72Z" style="fill:FILL"/>' +
        '<path d="M10 72Q10 18 50 15Q90 18 90 72Z" fill="url(#sgsh)"/>' +
        '<rect x="4" y="69" width="92" height="9" rx="4.5" style="fill:FILL"/>' +
        '<rect x="4" y="69" width="92" height="9" rx="4.5" fill="rgba(0,0,0,.16)"/>' +
        '<path d="M26 34Q31 24 43 21" stroke="#fff" stroke-opacity=".75" stroke-width="5" fill="none" stroke-linecap="round"/></svg>');
    },
    item: function (good) {
      if (G.pet) {
        if (good) {
          return '<svg viewBox="0 0 80 40" aria-hidden="true"><g fill="#D9A066" stroke="#B07A3E" stroke-width="1.5">' +
            '<circle cx="15" cy="13" r="8"/><circle cx="15" cy="27" r="8"/><circle cx="65" cy="13" r="8"/><circle cx="65" cy="27" r="8"/>' +
            '<rect x="15" y="13" width="50" height="14" rx="4" stroke="none"/></g></svg>';
        }
        return '<svg viewBox="0 0 60 60" aria-hidden="true"><circle cx="30" cy="30" r="24" fill="#E5484D"/>' +
          '<circle cx="22" cy="22" r="6" fill="#FFD166"/><circle cx="40" cy="37" r="4" fill="#FFD166"/></svg>';
      }
      var a = good ? '#C9A35A' : '#C9CED6', b = good ? '#A9853F' : '#9AA2AD';
      return '<svg viewBox="0 0 60 60" aria-hidden="true">' +
        '<rect x="8" y="24" width="44" height="30" rx="3" fill="' + a + '"/>' +
        '<rect x="5" y="17" width="50" height="10" rx="2" fill="' + a + '"/>' +
        '<rect x="26" y="17" width="8" height="37" fill="' + b + '"/>' +
        '<path d="M30 17C24 7 14 9 16 15C17 18 24 18 30 17ZM30 17C36 7 46 9 44 15C43 18 36 18 30 17Z" fill="' + b + '"/></svg>';
    },
    shield: '<svg viewBox="0 0 24 24" width="30" height="30" aria-hidden="true"><path d="M12 2l8 3v6c0 5-3.4 9.4-8 11-4.6-1.6-8-6-8-11V5z" fill="none" stroke="#C9A35A" stroke-width="1.6"/><path d="M12 8l1.2 2.6 2.8.3-2.1 1.9.6 2.8L12 14.2l-2.5 1.4.6-2.8-2.1-1.9 2.8-.3z" fill="#C9A35A"/></svg>',
    sound: function (on) {
      return '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/>' +
        (on ? '<path d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/>'
            : '<path d="M16 9l5 6M21 9l-5 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>') + '</svg>';
    }
  };

  G.build = function () {
    if (G.root) return;
    var r = document.createElement('div');
    r.id = 'sg-root';
    r.className = 'sg-' + G.C.skin;
    r.hidden = true;
    r.innerHTML =
      '<svg width="0" height="0" style="position:absolute" aria-hidden="true"><defs><linearGradient id="sgsh" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0" stop-color="#fff" stop-opacity=".2"/><stop offset="1" stop-color="#000" stop-opacity=".14"/></linearGradient></defs></svg>' +
      '<div class="sg-bd"></div>' +
      '<div class="sg-card" role="dialog" aria-modal="true" aria-labelledby="sg-h">' +
      '<button class="sg-x" type="button" data-a="close" aria-label="Close">&times;</button>' +
      '<div class="sg-body"></div><div class="sg-ov" hidden></div>' +
      '<div class="sg-live" aria-live="polite"></div></div>';
    document.body.appendChild(r);
    G.root = r;
    G.card = r.querySelector('.sg-card');
    G.body = r.querySelector('.sg-body');
    G.ov = r.querySelector('.sg-ov');
    G.live = r.querySelector('.sg-live');
  };

  G.viewTitle = function () {
    var heroes = '', coins = '';
    [1, 2, 3].forEach(function (l) { heroes += '<span class="sg-hero">' + G.svg.cover(G.colorFor(l)) + '</span>'; });
    [[10, 3], [15, 6], [20, 9]].forEach(function (x) {
      coins += '<div><span class="sg-coin on">$' + x[0] + '</span><b>Level ' + x[1] + '</b><small>on $' + G.minFor(x[0]) + '+</small></div>';
    });
    G.body.innerHTML = '<div class="sg-title"><p class="sg-eye">A SLEEK GAME</p>' +
      '<h2 id="sg-h" class="sg-serif sg-big">' + T.title + '</h2>' +
      '<div class="sg-heroes">' + heroes + '</div><p class="sg-txt">' + T.rules + '</p>' +
      '<div class="sg-coins">' + coins + '</div>' +
      '<button class="sg-btn sg-dk sg-wide" type="button" data-a="play">Play</button>' +
      '<p class="sg-eye sg-mut">' + (G.best ? 'BEST . LEVEL ' + G.best : "First run, let's go") + '</p></div>';
  };

  G.viewGame = function () {
    G.body.innerHTML = '<div class="sg-game"><div class="sg-hd">' +
      '<span class="sg-eye">LEVEL</span><span class="sg-num sg-serif" id="sg-h"></span><span class="sg-of">/ 10</span>' +
      '<span class="sg-cnt"></span><span class="sg-sp"></span><span class="sg-save"></span>' +
      '<button class="sg-snd" type="button" data-a="sound"></button></div>' +
      '<div class="sg-rail"><div class="sg-nodes"></div><p class="sg-rtxt"></p></div>' +
      '<div class="sg-stage"><p class="sg-eye sg-seye"></p><p class="sg-serif sg-head"></p>' +
      '<div class="sg-shelf"></div><div class="sg-ps"></div></div><div class="sg-foot"></div></div>';
  };

  G.renderHead = function () {
    var S = G.S, q = function (s) { return G.body.querySelector(s); };
    if (!q('.sg-num')) return;
    q('.sg-num').textContent = G.pad(S.level);
    q('.sg-cnt').textContent = G.lvl(S.level).n + ' ' + T.pieces;
    q('.sg-save').innerHTML = S.saveUsed ? '<s>SAVE USED</s>' : '1 SAVE';
    q('.sg-save').className = 'sg-save' + (S.saveUsed ? ' used' : '');
    var snd = q('.sg-snd');
    snd.innerHTML = G.svg.sound(G.sound);
    snd.setAttribute('aria-label', G.sound ? 'Sound on' : 'Sound off');
  };

  G.railText = function () {
    var S = G.S, c = S.cleared, h = S.held, nl = [3, 6, 9, 10].filter(function (x) { return x > c; })[0] || 10;
    var rem = nl - c, hold = h ? ' . holding $' + h : '';
    if (nl === 10) return rem + ' more to Legend' + hold;
    return rem + ' more to unlock $' + G.tierAt(nl) + ' off' + hold;
  };

  G.renderRail = function () {
    var S = G.S, c = S.cleared, h = '';
    var box = G.body.querySelector('.sg-nodes');
    if (!box) return;
    for (var l = 1; l <= 10; l++) {
      var t = G.tierAt(l);
      var cls = 'sg-n' + (l <= c ? ' done' : '') + (l === c + 1 ? ' cur' : '');
      if (l === 10) h += '<span class="' + cls + ' sg-dia"><i></i><small>Legend</small></span>';
      else if (t) h += '<span class="' + cls + ' sg-cn"><i>$' + t + '</i><small>on $' + G.minFor(t) + '+</small></span>';
      else h += '<span class="' + cls + ' sg-dot"><i></i></span>';
    }
    box.innerHTML = '<span class="sg-line"><b style="width:' + Math.min(100, (c / 9) * 100) + '%"></b></span>' + h;
    G.body.querySelector('.sg-rtxt').textContent = G.railText();
  };

  G.say = function (eye, head) {
    var e = G.body.querySelector('.sg-seye'), h = G.body.querySelector('.sg-head');
    if (e) e.textContent = eye;
    if (h) h.textContent = head;
    if (G.live) G.live.textContent = head;
  };

  G.buildPieces = function (cfg, color) {
    var ps = G.body.querySelector('.sg-ps');
    ps.innerHTML = '';
    G.P = [];
    G.n = cfg.n;
    var tgt = G.rand(cfg.n), dec = -1;
    if (cfg.decoy) { do { dec = G.rand(cfg.n); } while (dec === tgt); }
    for (var i = 0; i < cfg.n; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sg-p';
      b.disabled = true;
      b.setAttribute('aria-label', T.one + ' ' + (i + 1));
      var it = i === tgt ? G.svg.item(true) : i === dec ? G.svg.item(false) : '';
      var tag = cfg.decoy && i === tgt ? '<em class="sg-tag gold">FIND THIS</em>' : i === dec ? '<em class="sg-tag dark">NOT THIS</em>' : '';
      b.innerHTML = '<span class="sg-it">' + it + '</span>' + tag + '<span class="sg-cov">' + G.svg.cover(color) + '</span>';
      b.style.width = (cfg.n === 5 ? 17 : cfg.n === 4 ? 21 : 26) + '%';
      ps.appendChild(b);
      G.P.push({ el: b, slot: i, t: i === tgt });
    }
    G.place(0);
  };
  G.place = function (dur) {
    G.P.forEach(function (p) {
      p.el.style.transitionDuration = dur + 'ms';
      p.el.style.left = ((p.slot + 0.5) / G.n) * 100 + '%';
    });
  };
  G.lift = function (p, on) { p.el.classList.toggle('up', on); };

  G.foot = function (mode) {
    var f = G.body.querySelector('.sg-foot'), h = G.S.held, nx = G.S.cleared + 1, d = G.drop(h);
    if (!f) return;
    if (mode === 'decide') {
      f.innerHTML = (h ? '<button class="sg-btn sg-dk" type="button" data-a="cash"><b>Cash out $' + h + '</b><small>or risk a drop to $' + d + '</small></button>' : '') +
        '<button class="sg-btn sg-acc" type="button" data-a="next"><b>' + (h ? 'Keep going' : 'Next level') + '</b><small>Level ' + nx + ' next</small></button>';
    } else if (h) {
      var lock = mode === 'locked';
      f.innerHTML = '<button class="sg-btn sg-dk sg-wide" type="button" data-a="cash"' + (lock ? ' disabled' : '') + '><b>Cash out $' + h + (lock ? '' : ' now') +
        '</b><small>' + (lock ? 'Locked until the shuffle ends' : 'or risk dropping to $' + d) + '</small></button>';
    } else {
      f.innerHTML = '';
    }
  };

  G.toast = function (msg) {
    var t = document.createElement('div');
    t.className = 'sg-toast';
    t.textContent = msg;
    G.card.appendChild(t);
    setTimeout(function () { t.remove(); }, 2200);
  };

  G.confetti = function () {
    if (G.reduced()) return;
    var w = document.createElement('div'), cs = ['#C9A35A', '#E8CF8F', '#6B2E8F', '#F4A38C'];
    w.className = 'sg-conf';
    for (var i = 0; i < 40; i++) {
      var s = document.createElement('i');
      s.style.left = G.rand(100) + '%';
      s.style.background = cs[i % 4];
      s.style.animationDelay = G.rand(300) + 'ms';
      w.appendChild(s);
    }
    G.card.appendChild(w);
    setTimeout(function () { w.remove(); }, 1900);
  };
})();
